export const phone = () =>
	/* html */
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15.999">
			<path
				d="M20.028,17.03a13.439,13.439,0,0,0-2.807-1.878c-.841-.4-1.15-.4-1.745.033-.5.358-.816.691-1.387.566A8.274,8.274,0,0,1,11.3,13.689,8.215,8.215,0,0,1,9.24,10.9c-.121-.575.212-.891.566-1.387.429-.6.442-.9.033-1.745A13.173,13.173,0,0,0,7.961,4.963c-.612-.612-.75-.479-1.087-.358a6.186,6.186,0,0,0-1,.529A3,3,0,0,0,4.683,6.4c-.237.512-.512,1.466.887,3.957A22.079,22.079,0,0,0,9.452,15.53h0l0,0,0,0h0a22.165,22.165,0,0,0,5.177,3.882c2.491,1.4,3.445,1.125,3.957.887a2.952,2.952,0,0,0,1.262-1.2,6.186,6.186,0,0,0,.529-1C20.507,17.78,20.644,17.642,20.028,17.03Z"
				transform="translate(-4.49 -4.502)"
			/>
		</svg>`;
